import React from 'react';
import HomeListManager from '../admincomponents/HomeListManager';

function AdminHomeCounters() {
  return (
    <HomeListManager
      title="Counters"
      urlPath="home-counters"
      emptyMessage='No counters yet — click "Add" to create the first one (the "Our Extraordinary Achievement" numbers).'
      fields={[
        { name: 'number', label: 'Number', required: true, colClass: 'col-md-3', placeholder: 'e.g. 800' },
        { name: 'suffix', label: 'Suffix', colClass: 'col-md-3', placeholder: 'e.g. +' },
        { name: 'label', label: 'Label', required: true, colClass: 'col-md-6', placeholder: 'e.g. Students in UAE & India' },
      ]}
    />
  );
}

export default AdminHomeCounters;
